import React, { useEffect } from 'react'
import Button from '../components/Button'
import DropDownQuestion from '../components/DropDownQuestion'

export const TestQuestions1 = ({nextStep, handleChange, values}) => {

  useEffect(() => {
    document.documentElement.scrollTo({
      top: 0,
      left: 0,
    });
  }, [])
 
  const Continue = e => {
    e.preventDefault();
    nextStep();
  }


  return (
    <div className='__test-questions'>
      <h2>Oplysninger om din virksomhed</h2>
      <p>Oplysninger om din virksomhed</p>
      <form>
        <DropDownQuestion selectedValue={ values.qst1_1 === '' ? "Vælg et alternativ" : values.qst1_1 } title="Antal ansatte" values={["0-9", "10-19", "20-49", "50-99", "100-249", "250-500", "500+"]} onChange={handleChange('qst1_1')} />
        <DropDownQuestion selectedValue={ values.qst1_2 === '' ? "Vælg et alternativ" : values.qst1_2 } title="Branche" values={["Handel og transport", "Erhvervsservice", "Bygge og anlæg", "Ejendomshandel og udlejning", "Landbrug, skovbrug og fiskeri", "Kultur, fritid og anden service", "Industri, råstofindvinding og forsyning", "Information og kommunikation", "Finansiering og forsikring", "Offentlig administration, undervisning og sundhed", "Andet"]} onChange={handleChange('qst1_2')} />
        <div className='mt-2 mb-5'>
          <Button buttonText='Næste' onClick={Continue} disabled={(values.qst1_1 !== '' && values.qst1_2 !== '' ) ? false : true} />
        </div>
        
      </form>
    </div>
  )
}
